import { render, staticRenderFns } from "./FollowUserBox.vue?vue&type=template&id=6d26d52f&"
import script from "./FollowUserBox.vue?vue&type=script&lang=js&"
export * from "./FollowUserBox.vue?vue&type=script&lang=js&"
import style0 from "./FollowUserBox.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports